export default "__VITE_ASSET__ropSyXVZ__"